import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcReport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5 3.125v13.75h15V3.125h-15Zm13.75 12.5V4.375H3.75v11.25h12.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m14.231 10.49-3.347 3.348.884.884 3.347-3.347-.884-.884Z"
    />
    <path
      fill="currentColor"
      d="m11.768 10.494-.884.884 3.347 3.348.884-.884-3.347-3.348ZM7.258 14.742a2.14 2.14 0 0 1-2.141-2.134 2.141 2.141 0 1 1 4.283 0 2.134 2.134 0 0 1-2.142 2.134Zm0-3.025c-.491 0-.891.4-.891.891 0 .492.4.884.891.884a.89.89 0 0 0 .892-.884c0-.483-.4-.891-.892-.891ZM14.425 8.408 13 6.983l-1.425 1.425-.883-.883L13 5.217l2.308 2.308-.883.883ZM6.8 9.291 5.05 7.875l.783-.967.809.65L8.608 5.24l.95.809L6.8 9.29Z"
    />
  </svg>
);
export default SvgIcReport;
